import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { NgxTypeaheadModule } from 'ngx-typeahead';
import { DataTablesModule } from 'angular-datatables';

// import ngx-translate and the http loader
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule} from '@angular/common/http';

// main bootstrap
//import { routing } from './app.routes';
import { AppRoutingModule } from './app-routing.module';

// modules
import { NgxAdminLteModule } from './ngx-admin-lte';

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const modules = [
  BrowserModule,
  TranslateModule.forRoot({
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
    }
  }),
  FormsModule,
  NgxAdminLteModule,
  AppRoutingModule,
  //routing,
  /*AlertModule,
  DatepickerModule,*/
  BrowserModule,
  FormsModule,
  HttpClientModule,
  RouterModule,
  NgxTypeaheadModule,
  DataTablesModule
];

import { AppComponent } from './app.component';

// les pages
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { ClientComponent } from './pages/client/client.component';
import { ClientEditComponent } from './pages/client/edit/edit';
import { CategorieComponent } from './pages/categorie/categorie.component';
import { CategorieEditComponent } from './pages/categorie/edit/edit';
import { UserComponent } from './pages/user/user.component';
import { UserEditComponent } from './pages/user/edit/edit';
import { ProduitComponent } from './pages/produit/produit.component';
import { ProduitEditComponent } from './pages/produit/edit/edit';
import { PrestationComponent } from './pages/prestation/prestation.component';
import { PrestationEditComponent } from './pages/prestation/edit/edit';
import { FactureComponent } from './pages/facture/facture.component';
import { FactureEditComponent } from './pages/facture/edit/edit';
import { AchatComponent } from './pages/achat/achat.component';
import { AchatEditComponent } from './pages/achat/edit/edit';

const pages = [
    HomeComponent,
    LoginComponent,
    ClientComponent,
    ClientEditComponent,
    CategorieComponent,
    CategorieEditComponent,
    UserComponent,
    UserEditComponent,
    ProduitComponent,
    ProduitEditComponent,
    PrestationComponent,
    PrestationEditComponent,
    FactureComponent,
    FactureEditComponent,
    AchatComponent,
    AchatEditComponent
];

import { toProduitPipe } from './pipes/produit';
import { toCategoriePipe } from './pipes/categorie';
import { toClientPipe } from './pipes/client';
import { toUserPipe } from './pipes/user';
import { toPrestationPipe } from './pipes/prestation';
import { isInsideFilterPipe } from './pipes/is_inside.pipe';

const pipes = [
  toProduitPipe,
  toCategoriePipe,
  toClientPipe,
  toUserPipe,
  toPrestationPipe,
  isInsideFilterPipe
];

import { TitleService } from './services/title.service';
import { FactureService } from './services/data/facture.service';
import { ClientService } from './services/data/client.service';
import { CategorieService } from './services/data/categorie.service';
import { UserService } from './services/data/user.service';
import { ProduitService } from './services/data/produit.service';
import { PrestationService } from './services/data/prestation.service';
import { AchatService } from './services/data/achat.service';
import { NotificationService } from './services/notification.service';
import { Configuration } from './app.constants';

const services =  [
  Configuration,
  TitleService,
  FactureService,
  ClientService,
  CategorieService,
  UserService,
  ProduitService,
  PrestationService,
  AchatService,
  NotificationService
];

@NgModule({
  declarations: [
    AppComponent,
    ...pages,
    ...pipes
  ],
  imports: [
    ...modules
  ],
  providers: [
    ...services
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

